import { Configuration } from "../../../models";

export const configurationAppMapper = (configuration: Configuration) => {
  return {
    environment: configuration.environment,
  };
};
